import Box from "@mui/material/Box";
import { toChipBadgeColourSx, toChipColourSx } from "@/app/chip.utils";
import { OverflowTooltip } from "@/components/OverflowTooltip";
import type { OrderStatus } from "@/api/order/_models/Order";
import { orderListStatusChipHue } from "./orderListStatusChipColour";

interface OrderListStatusChipProps {
  /** How many systems have reported a status; shown as a pill after the label, hidden at 0. */
  count?: number;
  status: OrderStatus;
}

/** An order's status in its colour, on a soft tint of it, optionally followed by a count pill. */
export const OrderListStatusChip = (props: OrderListStatusChipProps) => {
  const { count, status } = props;
  const hue = orderListStatusChipHue(status);

  return (
    <Box
      sx={[
        toChipColourSx(hue),
        {
          alignItems: "center",
          borderRadius: 0.5,
          display: "inline-flex",
          fontSize: 12,
          fontWeight: 700,
          gap: 0.75,
          letterSpacing: "0.05em",
          lineHeight: "20px",
          maxWidth: "100%",
          px: 0.75,
          textTransform: "uppercase",
          verticalAlign: "middle",
        },
      ]}
    >
      <OverflowTooltip title={status}>
        <Box
          component="span"
          sx={{
            minWidth: 0,
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
          }}
        >
          {status}
        </Box>
      </OverflowTooltip>
      {count !== undefined && count > 0 && (
        <Box
          aria-label={`${count} systems reporting`}
          component="span"
          sx={[
            toChipBadgeColourSx(hue),
            {
              alignItems: "center",
              borderRadius: 999,
              display: "inline-flex",
              flexShrink: 0,
              fontSize: 11,
              height: 16,
              justifyContent: "center",
              letterSpacing: 0,
              minWidth: 16,
              px: 0.5,
            },
          ]}
        >
          {count}
        </Box>
      )}
    </Box>
  );
};
